;(function () {

"use strict";

require('air-datepicker');

;(function ($) { $.fn.datepicker.language['en'] = {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'mm/dd/yyyy',
    timeFormat: 'hh:ii aa',
    firstDay: 0
}; })(jQuery);

var DateInputView = Backbone.View.extend({
  initialize: function () {
    console.log('init date input view');
    this.vals = {};
    this.$input = this.$el.find('input[type="text"]');

    var $input = this.$input;
    var start;
    if (this.$input.val()) {
      var valid = (new Date(this.$input.val() * 1000)).getTime() > 0;
      if (valid) {
        start = new Date(this.$input.val() * 1000);
      }
    }

    this.$input.parent().datepicker({
      inline: true,
      language: 'en',
      onSelect: function onSelect(fd, date) {
        date.setHours(12);
        var unixtime = date.getTime() / 1000;
        $input.val(unixtime);
      }
    });

    if (start) {
      this.$input.parent().data('datepicker').selectDate(start);
    }
  }
});

module.exports = DateInputView;

}());